export default __webpack_public_path__ + "UI/assets/media/google_play_light-294ae833.png";